import React from 'react';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="bg-white rounded-xl shadow-lg border border-gray-200 mb-8">
          <div className="px-6 py-8 text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-3">
              Terms and Conditions
            </h1>
            <p className="text-gray-600">
              Last updated: {new Date().toLocaleDateString()}
            </p>
            <div className="mt-4 w-24 h-1 bg-blue-500 mx-auto rounded-full"></div>
          </div>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-xl shadow-lg border border-gray-200">
          <div className="px-6 py-8">
            <div className="prose max-w-none">
              
              {/* 1. Acceptance of Terms */}
              <section className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-blue-500 pl-4">1. Acceptance of Terms</h2>
                <p className="text-gray-700 mb-4">
                  By accessing and using the PromptHire AI Interview Platform ("Platform"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                </p>
              </section>

              {/* 2. Platform Description */}
              <section className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-blue-500 pl-4">2. Platform Description</h2>
                <p className="text-gray-700 mb-4">
                  PromptHire is an AI-powered interview platform that conducts automated interviews using artificial intelligence technology. The platform may include but is not limited to:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-4">
                  <li>Automated interview questions and assessments</li>
                  <li>Audio and video recording capabilities</li>
                  <li>Real-time analysis of candidate responses</li>
                  <li>Proctoring and monitoring features</li>
                  <li>Interview feedback and scoring</li>
                </ul>
              </section>

              {/* 3. User Eligibility */}
              <section className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-blue-500 pl-4">3. User Eligibility</h2>
                <p className="text-gray-700 mb-4">
                  You must be at least 18 years old to use this platform. By using the platform, you represent and warrant that:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-4">
                  <li>You are at least 18 years of age</li>
                  <li>You have the legal capacity to enter into this agreement</li>
                  <li>You will provide accurate and truthful information</li>
                  <li>You will not impersonate any other person or entity</li>
                </ul>
              </section>

              {/* 4. Privacy and Data Collection */}
              <section className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-blue-500 pl-4">4. Privacy and Data Collection</h2>
                <p className="text-gray-700 mb-4">
                  We collect and process personal data in accordance with our Privacy Policy. By using the platform, you consent to:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-4">
                  <li>Recording of audio and video during interviews</li>
                  <li>Collection of personal information provided during registration</li>
                  <li>Analysis of your responses and behavior during interviews</li>
                  <li>Storage of interview data for evaluation purposes</li>
                  <li>Sharing of data with authorized personnel for hiring decisions</li>
                </ul>
                <p className="text-gray-700 mb-4">
                  All interviews are recorded and monitored. Your data may be shared with potential employers and authorized third parties as part of the hiring process.
                </p>
              </section>

              {/* 5. Proctoring and Monitoring */}
              <section className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-blue-500 pl-4">5. Proctoring and Monitoring</h2>
                <p className="text-gray-700 mb-4">
                  The platform includes proctoring features to ensure interview integrity. You acknowledge and agree that:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-4">
                  <li>Your screen, audio, and video may be monitored during interviews</li>
                  <li>AI systems will analyze your behavior and responses</li>
                  <li>Any suspicious activity may be flagged and reported</li>
                  <li>You must maintain appropriate conduct throughout the interview</li>
                  <li>External assistance is strictly prohibited</li>
                </ul>
              </section>

              {/* 6. Prohibited Activities */}
              <section className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-blue-500 pl-4">6. Prohibited Activities</h2>
                <p className="text-gray-700 mb-4">
                  You agree not to engage in any of the following prohibited activities:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-4">
                  <li>Attempting to cheat, hack, or manipulate the interview process</li>
                  <li>Using external assistance or resources during interviews</li>
                  <li>Sharing interview questions or content with others</li>
                  <li>Impersonating another person or providing false information</li>
                  <li>Attempting to circumvent security measures</li>
                  <li>Using automated tools or bots to interact with the platform</li>
                  <li>Violating any applicable laws or regulations</li>
                </ul>
              </section>

              {/* 7. Intellectual Property */}
              <section className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-blue-500 pl-4">7. Intellectual Property Rights</h2>
                <p className="text-gray-700 mb-4">
                  The platform and its original content, features, and functionality are owned by PromptHire and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
                </p>
                <p className="text-gray-700 mb-4">
                  You may not reproduce, distribute, modify, or create derivative works of any content without explicit written permission.
                </p>
              </section>

              {/* 8. Limitation of Liability */}
              <section className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-blue-500 pl-4">8. Limitation of Liability</h2>
                <p className="text-gray-700 mb-4">
                  In no event shall PromptHire, its officers, directors, employees, or agents be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the platform.
                </p>
              </section>

              {/* 9. Disclaimers */}
              <section className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-blue-500 pl-4">9. Disclaimers</h2>
                <p className="text-gray-700 mb-4">
                  The platform is provided on an "AS IS" and "AS AVAILABLE" basis. PromptHire makes no representations or warranties of any kind, express or implied, as to the operation of the platform or the information, content, materials, or products included on the platform.
                </p>
              </section>

              {/* 10. Termination */}
              <section className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-blue-500 pl-4">10. Termination</h2>
                <p className="text-gray-700 mb-4">
                  We may terminate or suspend your access to the platform immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
                </p>
              </section>

              {/* 11. Governing Law */}
              <section className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-blue-500 pl-4">11. Governing Law</h2>
                <p className="text-gray-700 mb-4">
                  These Terms shall be interpreted and governed by the laws of the jurisdiction in which PromptHire operates, without regard to its conflict of law provisions.
                </p>
              </section>

              {/* 12. Changes to Terms */}
              <section className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-blue-500 pl-4">12. Changes to Terms</h2>
                <p className="text-gray-700 mb-4">
                  We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect.
                </p>
              </section>

              {/* 13. Contact Information */}
              <section className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-blue-500 pl-4">13. Contact Information</h2>
                <p className="text-gray-700 mb-4">
                  If you have any questions about these Terms and Conditions, please contact us at:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-gray-700">
                    <strong>Email:</strong> interview@prompthire.info<br />
                    
                  </p>
                </div>
              </section>

            </div>
          </div>
        </div>

        {/* Data Deletion Notice - Highlighted Box */}
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 p-8 mb-8 rounded-xl shadow-lg">
          <div className="text-center">
            <div className="flex justify-center mb-4">
              <div className="bg-blue-100 p-3 rounded-full">
                <svg className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
            <h3 className="text-xl font-bold text-blue-900 mb-3">
              Data Deletion Request
            </h3>
            <p className="text-blue-800 mb-4">
              If you wish to delete your personal data from our platform, please contact us at:
            </p>
            <div className="bg-white p-6 rounded-lg border-2 border-blue-200 shadow-md max-w-md mx-auto">
              <p className="text-gray-900 font-semibold mb-2">
                Email: <a href="mailto:interview@prompthire.info" className="text-blue-600 hover:text-blue-800 underline">
                  interview@prompthire.info
                </a>
              </p>
              <p className="text-sm text-gray-700">
                Please include your full name and email address used for registration in your request.
              </p>
            </div>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="mt-12 flex justify-center">
          <Link 
            to="/" 
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-10 rounded-xl transition duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;